/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocumentsFindAllResponse } from './InboundDocumentsFindAllResponse';
import {
    InboundDocumentsFindAllResponseFromJSON,
    InboundDocumentsFindAllResponseFromJSONTyped,
    InboundDocumentsFindAllResponseToJSON,
    InboundDocumentsFindAllResponseToJSONTyped,
} from './InboundDocumentsFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllInboundDocuments200Response
 */
export interface FindAllInboundDocuments200Response {
    /**
     * 
     */
    data?: InboundDocumentsFindAllResponse;
}

/**
 * Check if a given object implements the FindAllInboundDocuments200Response interface.
 */
export function instanceOfFindAllInboundDocuments200Response(value: object): value is FindAllInboundDocuments200Response {
    return true;
}

export function FindAllInboundDocuments200ResponseFromJSON(json: any): FindAllInboundDocuments200Response {
    return FindAllInboundDocuments200ResponseFromJSONTyped(json, false);
}

export function FindAllInboundDocuments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllInboundDocuments200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InboundDocumentsFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllInboundDocuments200ResponseToJSON(json: any): FindAllInboundDocuments200Response {
    return FindAllInboundDocuments200ResponseToJSONTyped(json, false);
}

export function FindAllInboundDocuments200ResponseToJSONTyped(value?: FindAllInboundDocuments200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InboundDocumentsFindAllResponseToJSON(value['data']),
    };
}

